import {
    observable,
    action,
    toJS,
    runInAction,
    computed
} from 'mobx';
import {ViewBase} from 'mutants-appfx';
import {Message} from 'tplus-components-touch';
import _clonedeep from 'lodash/cloneDeep'
const uiDefaultState={
    visible:true,
    enable:true,
    positive:true,
    tip:''
  }
class MemberStore extends ViewBase {
    get type(){
    return 'MemberStore';
    }

    @computed get uiState(){
        return {...this.uiDefaultState||{},...this.uiUpdateState}
    }
    @observable uiDefaultState;
    @observable uiUpdateState={};
   
    constructor(store,name){
        super(store,name);
        runInAction(()=>{
            this.uiDefaultState = Object.assign({},uiDefaultState)
        })
    }

    @action
    changeUiState( {state={}} ){
        Object.assign( this.uiUpdateState,state );
    }

    static fromJS(store) {
        return new MemberStore(store, 'MemberStore');
    }
}
export default MemberStore;
